import {
  image,
  eraser,
  freedraw,
  retouching,
  poly,
  grid,
  edgeGrid,
  ellipse,
  rectangle,
  boolean,
  retouchBrush,
  retouchGradient,
  retouchPattern,
  cloneStamp,
  type Plugin,
  colorChecker,
} from '@modules/editor';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const plugins: Plugin<any>[] = [
  freedraw,
  image,
  eraser,
  retouching,
  poly,
  ellipse,
  rectangle,
  grid,
  colorChecker,
  edgeGrid,
  boolean,
  retouchBrush,
  retouchGradient,
  retouchPattern,
  cloneStamp,
];
